module.exports = __webpack_public_path__ + "static/media/heart-grey.c3b78653.svg";